//个性化设置页面svg
import morenshezhi from "Assets/images/gexinghuashezhi/morenshezhi.svg";
import changyongshuju from "Assets/images/gexinghuashezhi/changyongshuju.svg";
import dailirenshezhi from "Assets/images/gexinghuashezhi/dailirenshezhi.svg";
import zhutishezhi from "Assets/images/gexinghuashezhi/zhutishezhi.svg";
import morenshezhi_red from "Assets/images/gexinghuashezhi/morenshezhi_red.svg";
import changyongshuju_red from "Assets/images/gexinghuashezhi/changyongshuju_red.svg";
import dailirenshezhi_red from "Assets/images/gexinghuashezhi/dailirenshezhi_red.svg";
import zhutishezhi_red from "Assets/images/gexinghuashezhi/zhutishezhi_red.svg";
import zhutipifu from "Assets/images/gexinghuashezhi/zhutipifu.svg";
import jituancaiwuhebing_red from "Assets/images/gexinghuashezhi/jituancaiwuhebing_red.svg";
import jituancaiwuhebing from "Assets/images/gexinghuashezhi/jituancaiwuhebing.svg";
import morenshezhi_black from "Assets/images/gexinghuashezhi/morenshezhi_black.svg";
import changyongshuju_black from "Assets/images/gexinghuashezhi/changyongshuju_black.svg";
import dailirenshezhi_black from "Assets/images/gexinghuashezhi/dailirenshezhi_black.svg";
import zhutishezhi_black from "Assets/images/gexinghuashezhi/zhutishezhi_black.svg";
import jituancaiwuhebing_black from "Assets/images/gexinghuashezhi/jituancaiwuhebing_black.svg";
import tubiaofengge from "Assets/images/gexinghuashezhi/tubiaofengge.svg";
import biaogeshezhi from "Assets/images/gexinghuashezhi/biaogeshezhi.svg";
import compact from "Assets/images/gexinghuashezhi/compact.svg";
import standard from "Assets/images/gexinghuashezhi/standard.svg";
import loose from "Assets/images/gexinghuashezhi/loose.svg";
import business from "Assets/images/gexinghuashezhi/business.svg";
import defaultIcon from "Assets/images/gexinghuashezhi/defaultIcon.svg";
// import defaultImg from "Assets/images/gexinghuashezhi/defaultIcon.svg";
import industry from "Assets/images/gexinghuashezhi/industry.svg";
import simple from "Assets/images/gexinghuashezhi/simple.svg";
import youth from "Assets/images/gexinghuashezhi/youth.svg";
import zihaodaxiao from "Assets/images/gexinghuashezhi/zihaodaxiao.svg";
import adaptive from "Assets/images/gexinghuashezhi/adaptive.svg";
import fixed from "Assets/images/gexinghuashezhi/fixed.svg";
import tight from "Assets/images/gexinghuashezhi/tight.svg";
import moderate from "Assets/images/gexinghuashezhi/moderate.svg";
import relax from "Assets/images/gexinghuashezhi/relax.svg";
import large from "Assets/images/gexinghuashezhi/large.svg";
import medium from "Assets/images/gexinghuashezhi/medium.svg";
import small from "Assets/images/gexinghuashezhi/small.svg";
import defaultLogo from "Assets/images/gexinghuashezhi/defaultLogo.png";
import orderLogo from "Assets/images/gexinghuashezhi/orderLogo.png";
import loginLogo from "Assets/images/gexinghuashezhi/loginLogo.png";
import loginPageBg from "Assets/images/gexinghuashezhi/loginPageBg.png";
import loginPageBg1 from "Assets/images/gexinghuashezhi/loginPageBg1.png";
import logoIcon from "Assets/images/gexinghuashezhi/logo-icon.svg";
import styleSetting from "Assets/images/gexinghuashezhi/style_setting.svg";
import desktopIcon from "Assets/images/gexinghuashezhi/desktopIcon.svg";
import cardIcon from "Assets/images/gexinghuashezhi/cardIcon.svg";
import insideTabIcon from "Assets/images/gexinghuashezhi/inside-tab.svg";
import outsideTabIcon from "Assets/images/gexinghuashezhi/outside-tab.svg";
import formupdown from "Assets/images/gexinghuashezhi/formupdown.png";
import formleftright from "Assets/images/gexinghuashezhi/formleftright.png";
import forminput from "Assets/images/gexinghuashezhi/forminput.png";
import formunderline from "Assets/images/gexinghuashezhi/formunderline.png";
import browserlogo from "Assets/images/gexinghuashezhi/browserlogo.png";
export default {
    morenshezhi,
    changyongshuju,
    dailirenshezhi,
    zhutishezhi,
    morenshezhi_red,
    changyongshuju_red,
    dailirenshezhi_red,
    zhutishezhi_red,
    zhutipifu,
    jituancaiwuhebing,
    jituancaiwuhebing_red,
    tubiaofengge,
    biaogeshezhi,
    compact,
    standard,
    loose,
    business,
    defaultIcon,
    // defaultImg,
    industry,
    simple,
    youth,
    morenshezhi_black,
    changyongshuju_black,
    dailirenshezhi_black,
    zhutishezhi_black,
    jituancaiwuhebing_black,
    zihaodaxiao,
    adaptive,
    fixed,
    tight,
    moderate,
    relax,
    large,
    medium,
    small,
    defaultLogo,
    orderLogo,
    loginLogo,
    loginPageBg,
    loginPageBg1,
    logoIcon,
    styleSetting,
    desktopIcon,
    cardIcon,
    insideTabIcon,
    outsideTabIcon,
    formupdown,
    formleftright,
    forminput,
    formunderline,
    browserlogo
};
